import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const ArenaAuthContext = createContext(null);

export const ArenaAuthProvider = ({ children }) => {
  const [arenaUser, setArenaUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/auth/arena-session`,
          { withCredentials: true }
        );
        if (isMounted && res.data?.success) {
          setArenaUser(res.data.user);
        }
      } catch (_) {
        // no arena session
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  const loginArena = async (email, password) => {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/auth/arena-login`,
      { email, password },
      { withCredentials: true }
    );
    if (res.data?.success) {
      // Cookie is set by server
      setArenaUser(res.data);
      return res.data;
    }
    throw new Error(res.data?.message || "Arena login failed");
  };

  const logoutArena = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/auth/arena-logout`,
        {},
        { withCredentials: true }
      );
    } catch (_) {
      // ignore
    } finally {
      setArenaUser(null);
    }
  };

  const value = useMemo(
    () => ({ arenaUser, setArenaUser, loading, loginArena, logoutArena }),
    [arenaUser, loading]
  );

  return (
    <ArenaAuthContext.Provider value={value}>{children}</ArenaAuthContext.Provider>
  );
};

export const useArenaAuth = () => useContext(ArenaAuthContext);


